// ═══════════════════════════════════════════════════════════════
// AGENCIAS · Regiones: grupos, nombres y coordenadas (region-geo.js)
// Las regiones de agencia son las cadenas de shared.REGIONS
// ("EU / España", "LATAM / México", "US / Canadá"…). Aquí vive todo lo
// que se deriva de ellas: su grupo, el nombre corto para mostrar, su
// bandera, el punto [lon, lat] donde se pinta en el mapa del Explorador y a qué zona
// pertenece cada punto de tierra del mapa, con world-countries.js (la
// guía ilumina la zona o el país bajo el ratón y deja elegirlos con un
// clic).
// Expone window.AgenciasRegionGeo.
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

window.AgenciasRegionGeo = (function () {
  'use strict';

  const t = (k, f) => window.AgenciasShared?.t(k, f) ?? f;

  const GROUPS = {
    EU: ['agencies_region_group_eu', 'Europa'],
    US: ['agencies_region_group_us', 'EE. UU. y Canadá'],
    LATAM: ['agencies_region_group_latam', 'LATAM'],
    BR: ['agencies_region_group_br', 'Brasil'],
    ASIA: ['agencies_region_group_asia', 'Asia'],
    ME: ['agencies_region_group_me', 'Oriente Medio'],
    AF: ['agencies_region_group_af', 'África'],
    OC: ['agencies_region_group_oc', 'Oceanía'],
  };

  // [lon, lat] aproximado del centro de cada país.
  const COORDS = {
    'EU / España': [-3.7, 40.2], 'EU / Francia': [2.4, 46.6], 'EU / Alemania': [10.4, 51.1],
    'EU / Italia': [12.6, 42.8], 'EU / Portugal': [-8.2, 39.6], 'EU / Reino Unido': [-2.0, 53.5],
    'EU / Países Bajos': [5.3, 52.2], 'EU / Bélgica': [4.5, 50.6], 'EU / Austria': [14.5, 47.6],
    'EU / Suiza': [8.2, 46.8], 'EU / Polonia': [19.4, 52.1], 'EU / Suecia': [15.6, 62.0],
    'EU / Noruega': [9.5, 61.0], 'EU / Dinamarca': [9.5, 56.0], 'EU / Finlandia': [26.0, 63.0],
    'EU / Irlanda': [-8.0, 53.2], 'EU / República Checa': [15.5, 49.8], 'EU / Rumanía': [25.0, 45.9],
    'EU / Hungría': [19.5, 47.2], 'EU / Grecia': [22.0, 39.1], 'EU / Croacia': [15.9, 45.3],
    'EU / Bulgaria': [25.5, 42.7], 'EU / Eslovaquia': [19.7, 48.7], 'EU / Eslovenia': [14.9, 46.1],
    'EU / Lituania': [23.9, 55.3], 'EU / Letonia': [24.6, 56.9], 'EU / Estonia': [25.0, 58.6],
    'EU / Luxemburgo': [6.1, 49.8], 'EU / Malta': [14.4, 35.9], 'EU / Chipre': [33.2, 35.1],
    'EU / Islandia': [-18.6, 64.9], 'EU / Serbia': [20.9, 44.0], 'EU / Ucrania': [31.2, 49.0],
    'EU / Turquía': [35.2, 39.0], 'EU / Rusia': [40.0, 56.0],

    'US / Estados Unidos': [-98.5, 39.5], 'US / Canadá': [-106.0, 56.5],

    'LATAM / México': [-102.5, 23.6], 'LATAM / Argentina': [-64.0, -34.0], 'LATAM / Colombia': [-73.1, 4.1],
    'LATAM / Chile': [-71.0, -33.5], 'LATAM / Perú': [-75.0, -9.2], 'LATAM / Ecuador': [-78.4, -1.5],
    'LATAM / Venezuela': [-66.2, 7.1], 'LATAM / Bolivia': [-64.9, -16.7], 'LATAM / Paraguay': [-58.4, -23.4],
    'LATAM / Uruguay': [-56.0, -32.8], 'LATAM / Costa Rica': [-84.0, 9.9], 'LATAM / Panamá': [-80.1, 8.5],
    'LATAM / República Dominicana': [-70.5, 18.9], 'LATAM / Guatemala': [-90.3, 15.7],
    'LATAM / Honduras': [-86.6, 14.8], 'LATAM / El Salvador': [-88.9, 13.8], 'LATAM / Nicaragua': [-85.0, 12.9],
    'LATAM / Cuba': [-79.0, 21.8],

    'BR / Brasil': [-51.9, -12.0],

    'ASIA / China': [104.2, 35.0], 'ASIA / Japón': [138.3, 36.2], 'ASIA / Corea del Sur': [127.8, 36.4],
    'ASIA / India': [78.9, 21.8], 'ASIA / Tailandia': [101.0, 15.1], 'ASIA / Vietnam': [106.3, 16.0],
    'ASIA / Filipinas': [122.0, 12.3], 'ASIA / Indonesia': [113.9, -1.5], 'ASIA / Malasia': [102.0, 4.2],
    'ASIA / Singapur': [103.8, 1.35], 'ASIA / Taiwán': [121.0, 23.7], 'ASIA / Pakistán': [69.3, 30.4],
    'ASIA / Bangladesh': [90.4, 23.7], 'ASIA / Sri Lanka': [80.7, 7.9], 'ASIA / Myanmar': [96.0, 21.0],
    'ASIA / Camboya': [104.9, 12.6], 'ASIA / Nepal': [84.1, 28.4], 'ASIA / Mongolia': [103.8, 46.9],
    'ASIA / Kazajistán': [66.9, 48.0], 'ASIA / Uzbekistán': [64.6, 41.4], 'ASIA / Hong Kong': [114.2, 22.3],
    'ASIA / Macao': [113.5, 22.2],

    'ME / Emiratos Árabes': [54.0, 23.9], 'ME / Arabia Saudita': [45.1, 23.9], 'ME / Israel': [34.9, 31.0],
    'ME / Qatar': [51.2, 25.3], 'ME / Kuwait': [47.5, 29.3], 'ME / Bahréin': [50.6, 26.0],
    'ME / Omán': [57.0, 21.5], 'ME / Jordania': [36.2, 30.6], 'ME / Líbano': [35.9, 33.9],

    'AF / Sudáfrica': [24.0, -29.0], 'AF / Nigeria': [8.7, 9.1], 'AF / Kenia': [37.9, 0.0],
    'AF / Egipto': [30.8, 26.8], 'AF / Marruecos': [-7.1, 31.8],

    'OC / Australia': [134.5, -25.7], 'OC / Nueva Zelanda': [172.5, -41.5],
  };

  // Encuadre [oeste, sur, este, norte] de cada zona para el zoom del mapa.
  const GROUP_BOUNDS = {
    EU: [-12, 35, 42, 66], US: [-141, 24, -52, 64], LATAM: [-118, -56, -34, 32], BR: [-74, -34, -34, 6],
    ASIA: [60, -10, 146, 55], ME: [33, 12, 60, 38], AF: [-18, -35, 52, 37], OC: [112, -48, 180, -8],
  };

  // ── Zona y país de un punto del mapa (groupAt / regionAt) ────────
  // world-countries.js dice de qué país de Natural Earth es cada celda de
  // tierra (la misma fuente y rejilla que la tierra del mapa); aquí, a qué
  // zona va cada país y qué región de agencia es. '' = sin zona o sin
  // región (Groenlandia, Bielorrusia…): ni se ilumina ni se elige.
  // Sin la máscara cargada, todo es ''.

  // Región → país de Natural Earth cuando el nombre no coincide.
  const NE_NAMES = {
    'EU / España': 'Spain', 'EU / Francia': 'France', 'EU / Alemania': 'Germany', 'EU / Italia': 'Italy',
    'EU / Reino Unido': 'United Kingdom', 'EU / Países Bajos': 'Netherlands', 'EU / Bélgica': 'Belgium',
    'EU / Suiza': 'Switzerland', 'EU / Polonia': 'Poland', 'EU / Suecia': 'Sweden', 'EU / Noruega': 'Norway',
    'EU / Dinamarca': 'Denmark', 'EU / Finlandia': 'Finland', 'EU / Irlanda': 'Ireland',
    'EU / República Checa': 'Czechia', 'EU / Rumanía': 'Romania', 'EU / Hungría': 'Hungary',
    'EU / Grecia': 'Greece', 'EU / Croacia': 'Croatia', 'EU / Eslovaquia': 'Slovakia', 'EU / Eslovenia': 'Slovenia',
    'EU / Lituania': 'Lithuania', 'EU / Letonia': 'Latvia', 'EU / Luxemburgo': 'Luxembourg',
    'EU / Chipre': ['Cyprus', 'N. Cyprus'], 'EU / Islandia': 'Iceland', 'EU / Ucrania': 'Ukraine',
    'EU / Turquía': 'Turkey', 'EU / Rusia': 'Russia',
    'US / Estados Unidos': ['United States of America', 'Puerto Rico'], 'US / Canadá': 'Canada',
    'LATAM / México': 'Mexico', 'LATAM / Perú': 'Peru', 'LATAM / Panamá': 'Panama',
    'LATAM / República Dominicana': 'Dominican Rep.', 'BR / Brasil': 'Brazil',
    'ASIA / Japón': 'Japan', 'ASIA / Corea del Sur': 'South Korea', 'ASIA / Tailandia': 'Thailand',
    'ASIA / Filipinas': 'Philippines', 'ASIA / Malasia': 'Malaysia', 'ASIA / Taiwán': 'Taiwan',
    'ASIA / Pakistán': 'Pakistan', 'ASIA / Camboya': 'Cambodia', 'ASIA / Kazajistán': 'Kazakhstan',
    'ASIA / Uzbekistán': 'Uzbekistan', 'ME / Emiratos Árabes': 'United Arab Emirates',
    'ME / Arabia Saudita': 'Saudi Arabia', 'ME / Omán': 'Oman', 'ME / Jordania': 'Jordan', 'ME / Líbano': 'Lebanon',
    'AF / Sudáfrica': 'South Africa', 'AF / Kenia': 'Kenya', 'AF / Egipto': 'Egypt', 'AF / Marruecos': 'Morocco',
    'OC / Nueva Zelanda': 'New Zealand',
  };
  // Zona de los países sin región de agencia (los que tienen, la de su región).
  const OTHER_COUNTRIES = {
    EU: ['Albania', 'Belarus', 'Bosnia and Herz.', 'Kosovo', 'Macedonia', 'Moldova', 'Montenegro', 'Georgia',
      'Armenia', 'Azerbaijan'],
    LATAM: ['Belize', 'Haiti', 'Jamaica', 'Bahamas', 'Trinidad and Tobago', 'Guyana', 'Suriname'],
    ASIA: ['Afghanistan', 'Bhutan', 'Brunei', 'Kyrgyzstan', 'Laos', 'North Korea', 'Tajikistan', 'Timor-Leste',
      'Turkmenistan'],
    ME: ['Iran', 'Iraq', 'Palestine', 'Syria', 'Yemen'],
    AF: ['Algeria', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi', 'Cameroon', 'Central African Rep.',
      'Chad', 'Congo', "Côte d'Ivoire", 'Dem. Rep. Congo', 'Djibouti', 'Eq. Guinea', 'Eritrea', 'eSwatini',
      'Ethiopia', 'Gabon', 'Gambia', 'Ghana', 'Guinea', 'Guinea-Bissau', 'Lesotho', 'Liberia', 'Libya',
      'Madagascar', 'Malawi', 'Mali', 'Mauritania', 'Mozambique', 'Namibia', 'Niger', 'Rwanda', 'S. Sudan',
      'Senegal', 'Sierra Leone', 'Somalia', 'Somaliland', 'Sudan', 'Tanzania', 'Togo', 'Tunisia', 'Uganda',
      'W. Sahara', 'Zambia', 'Zimbabwe'],
    OC: ['Papua New Guinea', 'Fiji', 'New Caledonia', 'Solomon Is.', 'Vanuatu'],
  };
  let lookup = null;   // { regionOf: país → región, groupOf: país → zona }
  function countryLookup() {
    if (lookup) return lookup;
    const regionOf = new Map(), groupOfCountry = new Map();
    for (const region of Object.keys(COORDS)) {
      for (const name of [].concat(NE_NAMES[region] || rawPlace(region))) {
        regionOf.set(name, region);
        groupOfCountry.set(name, groupOf(region));
      }
    }
    for (const [g, names] of Object.entries(OTHER_COUNTRIES)) for (const name of names) groupOfCountry.set(name, g);
    lookup = { regionOf, groupOf: groupOfCountry };
    return lookup;
  }

  let mask = null;
  function countryMask() {
    if (mask) return mask;
    const src = window.AgenciasWorldCountries;
    if (!src) return null;
    const rows = src.rows.split(';');
    const cells = new Uint16Array(src.cols * rows.length);
    rows.forEach((row, r) => {
      let c = r * src.cols;
      for (const run of row.split(',')) {
        const [len, idx] = run.split(':');
        const n = parseInt(len, 36);
        if (idx) cells.fill(parseInt(idx, 36), c, c + n);
        c += n;
      }
    });
    mask = { ...src, nrows: rows.length, cells };
    return mask;
  }
  /** País de Natural Earth en ese punto ('' en el mar o sin máscara). */
  function countryAt(lon, lat) {
    const m = countryMask();
    if (!m) return '';
    const c = Math.floor((lon + 180) / m.step), r = Math.floor((m.top - lat) / m.step);
    if (r < 0 || r >= m.nrows || c < 0 || c >= m.cols) return '';
    const i = m.cells[r * m.cols + c];
    return i ? m.names[i - 1] : '';
  }

  /** Zona ('EU', 'LATAM'…) de un punto de tierra, o ''. */
  function groupAt(lon, lat) {
    const name = countryAt(lon, lat);
    // Rusia: Europa hasta los Urales; Siberia, Asia.
    if (name === 'Russia') return lon >= 60 || lon < -150 ? 'ASIA' : 'EU';
    // Francia incluye la Guayana Francesa.
    if (name === 'France' && lon < -20) return 'LATAM';
    return countryLookup().groupOf.get(name) || '';
  }

  /**
   * Región de agencia ("EU / España") de un punto de tierra, o ''. Solo
   * dentro de su zona (la Siberia rusa no es «EU / Rusia»).
   */
  function regionAt(lon, lat) {
    const region = countryLookup().regionOf.get(countryAt(lon, lat)) || '';
    return region && groupOf(region) === groupAt(lon, lat) ? region : '';
  }

  /** Regiones de una zona con punto en el mapa ("EU / España", "EU / Francia"…). */
  function regionsOf(group) {
    return Object.keys(COORDS).filter(r => groupOf(r) === group);
  }

  function groupOf(region) {
    const g = String(region || '').split(' / ')[0];
    return GROUPS[g] ? g : '';
  }

  function groupLabel(group) {
    const g = GROUPS[group];
    return g ? t(g[0], g[1]) : '';
  }

  /** El sitio tal cual se guarda: "LATAM / México" → "México"; "Otro" o texto libre → tal cual. */
  function rawPlace(region) {
    const s = String(region || '');
    return s.includes(' / ') ? s.split(' / ').slice(1).join(' / ') : s;
  }

  // ── El país en el idioma de la app ───────────────────────────────
  // Las regiones se guardan con el nombre en español ("EU / España"): es su
  // identificador y no cambia. Lo que se ENSEÑA sale de Intl.DisplayNames con
  // el código ISO del país (tabla ISO de abajo), en el idioma de la app; en
  // español, el nombre de la región tal cual. Sin código (un estado antiguo
  // "US / Texas", texto libre), el nombre guardado.
  const OTHER_REGION = 'Otro';
  // Con el nombre largo, Hong Kong y Macao salen como «RAE de Hong Kong (China)».
  const SHORT_NAMES = new Set(['hk', 'mo']);
  const displayNames = new Map();
  function appLang() {
    let lang = '';
    try { lang = window.i18n?.getCurrentLanguage?.() || ''; } catch (_) { /* */ }
    if (!lang) { try { lang = localStorage.getItem('tikcontrol_language') || ''; } catch (_) { /* */ } }
    return String(lang || 'es').toLowerCase().split(/[-_]/)[0];
  }
  function countryName(code, lang) {
    const style = SHORT_NAMES.has(code) ? 'short' : 'long';
    const key = lang + '|' + style;
    let dn = displayNames.get(key);
    if (dn === undefined) {
      try { dn = typeof Intl !== 'undefined' && Intl.DisplayNames ? new Intl.DisplayNames([lang], { type: 'region', style }) : null; }
      catch (_) { dn = null; }
      displayNames.set(key, dn);
    }
    if (!dn) return '';
    try {
      const name = dn.of(code.toUpperCase());
      return name && name !== code.toUpperCase() ? name : '';
    } catch (_) { return ''; }
  }

  /** Nombre del país para enseñarlo: "EU / España" → "Spain" (en inglés), "Espagne"… */
  function placeName(region) {
    const raw = rawPlace(region);
    if (raw === OTHER_REGION) return t('agencies_region_other', 'Otro');
    const lang = appLang();
    if (lang === 'es') return raw;
    const code = ISO[raw];
    return (code && countryName(code, lang)) || raw;
  }

  /** Etiqueta de ubicación de una ficha: "España", "Canadá", "México · LATAM". */
  function regionLabel(region) {
    if (!region) return '';
    const place = placeName(region);
    return groupOf(region) === 'LATAM' ? `${place} · ${groupLabel('LATAM')}` : place;
  }

  /**
   * La región entera para las listas del equipo: «Europa / España»,
   * «Europe / Spain»; una zona sola ('EU') → «Europa»; «Otro» o texto libre,
   * su nombre.
   */
  function fullLabel(region) {
    const r = String(region || '');
    if (!r) return '';
    const g = groupOf(r);
    if (!g) return placeName(r);
    if (!r.includes(' / ')) return groupLabel(g);
    return `${groupLabel(g)} / ${placeName(r)}`;
  }

  /**
   * Región tal cual se usa hoy. Hasta oct-2026 la zona US eran los 50 estados
   * ("US / Texas"…) y Puerto Rico; ahora son dos países. Lo que quede guardado
   * con un estado (agencias, la región elegida en la guía) cuenta como
   * "US / Estados Unidos".
   */
  function normalize(region) {
    const r = String(region || '');
    return groupOf(r) === 'US' && !COORDS[r] ? 'US / Estados Unidos' : r;
  }

  // Bandera de cada país (ISO 3166-1 alfa-2), por su nombre en la región.
  const ISO = {
    'España': 'es', 'Francia': 'fr', 'Alemania': 'de', 'Italia': 'it', 'Portugal': 'pt', 'Reino Unido': 'gb',
    'Países Bajos': 'nl', 'Bélgica': 'be', 'Austria': 'at', 'Suiza': 'ch', 'Polonia': 'pl', 'Suecia': 'se',
    'Noruega': 'no', 'Dinamarca': 'dk', 'Finlandia': 'fi', 'Irlanda': 'ie', 'República Checa': 'cz',
    'Rumanía': 'ro', 'Hungría': 'hu', 'Grecia': 'gr', 'Croacia': 'hr', 'Bulgaria': 'bg', 'Eslovaquia': 'sk',
    'Eslovenia': 'si', 'Lituania': 'lt', 'Letonia': 'lv', 'Estonia': 'ee', 'Luxemburgo': 'lu', 'Malta': 'mt',
    'Chipre': 'cy', 'Islandia': 'is', 'Serbia': 'rs', 'Ucrania': 'ua', 'Turquía': 'tr', 'Rusia': 'ru',
    'Estados Unidos': 'us', 'Canadá': 'ca',
    'México': 'mx', 'Argentina': 'ar', 'Colombia': 'co', 'Chile': 'cl', 'Perú': 'pe', 'Ecuador': 'ec',
    'Venezuela': 've', 'Bolivia': 'bo', 'Paraguay': 'py', 'Uruguay': 'uy', 'Costa Rica': 'cr', 'Panamá': 'pa',
    'República Dominicana': 'do', 'Guatemala': 'gt', 'Honduras': 'hn', 'El Salvador': 'sv', 'Nicaragua': 'ni',
    'Cuba': 'cu', 'Brasil': 'br',
    'China': 'cn', 'Japón': 'jp', 'Corea del Sur': 'kr', 'India': 'in', 'Tailandia': 'th', 'Vietnam': 'vn',
    'Filipinas': 'ph', 'Indonesia': 'id', 'Malasia': 'my', 'Singapur': 'sg', 'Taiwán': 'tw', 'Pakistán': 'pk',
    'Bangladesh': 'bd', 'Sri Lanka': 'lk', 'Myanmar': 'mm', 'Camboya': 'kh', 'Nepal': 'np', 'Mongolia': 'mn',
    'Kazajistán': 'kz', 'Uzbekistán': 'uz', 'Hong Kong': 'hk', 'Macao': 'mo',
    'Emiratos Árabes': 'ae', 'Arabia Saudita': 'sa', 'Israel': 'il', 'Qatar': 'qa', 'Kuwait': 'kw',
    'Bahréin': 'bh', 'Omán': 'om', 'Jordania': 'jo', 'Líbano': 'lb',
    'Sudáfrica': 'za', 'Nigeria': 'ng', 'Kenia': 'ke', 'Egipto': 'eg', 'Marruecos': 'ma',
    'Australia': 'au', 'Nueva Zelanda': 'nz',
  };
  /** Código ISO del país de una región ('es', 'ca'…), o '' (zonas, «Otro»). */
  function flagCode(region) {
    const r = normalize(region);
    return COORDS[r] ? (ISO[rawPlace(r)] || '') : '';
  }
  /**
   * Imagen de la bandera de una región (flagcdn.com, el mismo servicio que
   * ya usan los widgets; anchos 20/40/80/160), o '' si no tiene. Quien la
   * pinte debe prever que no cargue.
   */
  function flagUrl(region, width) {
    const code = flagCode(region);
    return code ? `https://flagcdn.com/w${width || 80}/${code}.png` : '';
  }

  function coords(region) { return COORDS[region] || null; }
  function groupBounds(group) { return GROUP_BOUNDS[group] || null; }

  /**
   * Encuadre [oeste, sur, este, norte] de la tierra de una región (país), o
   * null sin la máscara de países. Deja fuera el 1,5 % de celdas de cada
   * extremo: unas islas lejanas no alejan el mapa del resto del país.
   */
  const boundsCache = new Map();
  function regionBounds(region) {
    if (boundsCache.has(region)) return boundsCache.get(region);
    const m = countryMask();
    if (!m || !COORDS[region]) return null;
    const ids = new Set();
    m.names.forEach((name, i) => { if (countryLookup().regionOf.get(name) === region) ids.add(i + 1); });
    const group = groupOf(region);
    const cols = new Uint32Array(m.cols), rows = new Uint32Array(m.nrows);
    let total = 0;
    for (let r = 0; r < m.nrows; r++) {
      const lat = m.top - (r + 0.5) * m.step;
      for (let c = 0; c < m.cols; c++) {
        if (!ids.has(m.cells[r * m.cols + c])) continue;
        if (groupAt((c + 0.5) * m.step - 180, lat) !== group) continue;   // la Guayana no es «EU / Francia»
        cols[c]++; rows[r]++; total++;
      }
    }
    let out = null;
    if (total) {
      const cut = total * 0.015;
      const edge = (counts, from, step) => {
        let sum = 0, i = from;
        for (; i >= 0 && i < counts.length; i += step) { sum += counts[i]; if (sum > cut) break; }
        return i;
      };
      const c0 = edge(cols, 0, 1), c1 = edge(cols, m.cols - 1, -1);
      const r0 = edge(rows, 0, 1), r1 = edge(rows, m.nrows - 1, -1);
      out = [c0 * m.step - 180, m.top - (r1 + 1) * m.step, (c1 + 1) * m.step - 180, m.top - r0 * m.step];
    }
    boundsCache.set(region, out);
    return out;
  }

  /** ¿La agencia (región) casa con el filtro? Filtro = '' | 'group:XX' | región exacta. */
  function matches(region, filter) {
    if (!filter) return true;
    if (filter.startsWith('group:')) return groupOf(region) === filter.slice(6);
    return region === filter;
  }

  return { GROUPS: Object.keys(GROUPS), groupOf, groupLabel, placeName, rawPlace, regionLabel, fullLabel, coords, groupBounds, regionBounds, matches, regionsOf, groupAt, regionAt, normalize, flagCode, flagUrl };
})();
